import React from 'react';
import '../App.css';

function AboutUs() {
  return (
    <section id="about">
      <h2>关于我们</h2>
      <div style={{maxWidth: 800, margin: '0 auto', textAlign: 'center', color: '#444', fontSize: '1.1rem'}}>
        <p>项目团队由医疗、AI、云计算等领域的专家组成，致力于用数字化和AI技术推动医疗健康行业创新。</p>
        <p style={{marginTop: 18}}>专注于为医院、科研机构、政府和企业提供高效、安全、智能的健康管理平台。</p>
        <p style={{marginTop: 18}}>团队使命：<b>让每个人都能享受智能、个性化的健康服务</b>。</p>
        <p style={{marginTop: 18}}>我们相信：<b>科技将重塑医疗服务模式，提升全民健康福祉</b>。</p>
      </div>
    </section>
  );
}
export default AboutUs; 